// extracted by mini-css-extract-plugin
export var parcelRow = "_uq-0";